<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="bg-white">
    <div class="">
      <div role="list" class="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div class="group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid  hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark" :class="[ hardwareProductAdded ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]">
          <div
            @click="handleClickAddHardwareProduct"
            class="transition duration-250 relative flex-1 flex items-center justify-between "
            :class="[(hardwareProductAdded ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-2xl transition duration-250 text-black font-poppins-bold" :class="[hardwareProductAdded ? 'text-white' : 'text-black']">Yes</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-start justify-start ">
              <button v-if="!hardwareProductAdded" type="button" class="text-right mr-2 w-7 h-7 text-white rounded-full border border-solid"
                :class="[ hardwareProductAdded ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                >
              </button>
              <CheckCircleSolidIcon v-if="hardwareProductAdded" class="text-right pr-2 w-8 h-8 text-white" aria-hidden="true" />
            </div>
          </div>
        </div>
        <div class="group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid  hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark" :class="[ !hardwareProductAdded ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]">
          <div
            @click="handleClickRemoveHardwareProduct"
            class="transition duration-250 relative flex-1 flex items-center justify-between"
            :class="[(!hardwareProductAdded ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-2xl transition duration-250 text-black font-poppins-bold" :class="[hardwareProductAdded ? 'text-black' : 'text-white']">No</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-start justify-start ">
              <button v-if="hardwareProductAdded" type="button" class="text-right mr-2 w-7 h-7 text-white rounded-full border border-solid"
                :class="[ !hardwareProductAdded ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                >
              </button>
              <CheckCircleSolidIcon v-if="!hardwareProductAdded" class="text-right pr-2 w-8 h-8 text-white" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="hardwareProductAdded">
        <div class="pt-6 mt-4 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4">
          <HardwareSelectorProduct
            v-for="product in products"
            @handle-select-product="handleSelectProduct"
            :product="product"
            :key="product.name"
            :isSelectedProduct="isSelectedProduct(product)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>

import { defineProps, defineEmits, ref } from 'vue';
import HardwareSelectorProduct from './HardwareSelectorProduct.vue';
import { CheckCircleIcon } from '@heroicons/vue/outline';
import { CheckCircleIcon as CheckCircleSolidIcon } from '@heroicons/vue/solid';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}

const props = defineProps<{
  products: Array<Product>,
  isHardwareAdded: boolean,
  selected: string
}>();

const emit = defineEmits<{(e: 'onHardwareSelected', id: string): void, (e: 'onHardwareToggled', isVoipAdded: boolean): void}>();

const hardwareProductAdded = ref(false);
const productSelected = ref<Product|null>();

const handleClickAddHardwareProduct = () => {
  hardwareProductAdded.value = true;
  emit('onHardwareToggled', true);
};

const handleClickRemoveHardwareProduct = () => {
  hardwareProductAdded.value = false;
  emit('onHardwareToggled', false);
};

const handleSelectProduct = (product: Product): void => {
  productSelected.value = product;
  emit('onHardwareSelected', product.id);
};

const isSelectedProduct = (product: Product): boolean => {
  return product.id === props.selected;
};

</script>
